<template>
  <div class="wallet">

    <el-row :gutter="30" class="mt-30">
      <el-col :span="24">
        <div class="wall">
          <div class="wall-head">资金总览</div>
          <el-tabs v-if="'hblsmw888@163.com' === userInfo.username" v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="2026" name="2026">
            </el-tab-pane>
            <el-tab-pane label="2025" name="2025">
            </el-tab-pane>
            <el-tab-pane label="2024" name="2024">
            </el-tab-pane>
            <el-tab-pane label="2023" name="2023">
            </el-tab-pane>
          </el-tabs>
          <div class="mt-10 p-20 flex-around" v-loading="cashLoading">
            <div>
              <div>
                <span class="fs-30 mr-5 color-primary">{{ account.baofoo_account || 0 }}</span>
                <small>元</small>
              </div>
              <div class="mt-20 color-lightGray fs-12">
                可用余额 |
                <router-link to="/wallet/withdraw" class="color-blue">提现</router-link>
              </div>
            </div>
            <div>
              <div>
                <span class="fs-30 mr-5 color-primary">{{ account.total_account || 0 }}</span>
                <small>元</small>
              </div>
              <div class="mt-20 color-lightGray fs-12">
                总营业额
              </div>
            </div>
            <div>
              <div>
                <span class="fs-30 mr-5 color-primary">{{ account.transit_account || 0 }}</span>
                <small>元</small>
              </div>
              <div class="mt-20 color-lightGray fs-12">
                线上营业额
              </div>
            </div>
            <div>
              <div>
                <span class="fs-30 mr-5 color-primary">{{ account.outside_account || 0 }}</span>
                <small>元</small>
              </div>
              <div class="mt-20 color-lightGray fs-12">
                线下营业额
              </div>
            </div>
            <div>
              <div>
                <span class="fs-30 mr-5 color-primary">{{$store.getters.userInfo.guarantee_balance || 0}}</span>
                <small>元</small>
              </div>
              <div class="mt-20 color-lightGray fs-12">
                保证金 |
                <router-link to="/wallet/charge" class="color-blue">充值</router-link>
              </div>
            </div>
          </div>
        </div>
      </el-col>

      <!-- <el-col :span="8">
        <div class="wall">
          <div class="wall-head">账户信息</div>
          <div class="mt-10 p-20 container flex-between" style="height: 68px;">
            <span class="color-lightGray">默认公帐信息</span>
          </div>
        </div>
      </el-col> -->
    </el-row>

    <div class="wall mt-30">
      <div class="wall-head">资金明细</div>
      <div class="search flex-inline flex-between">
        <el-form :inline="true" :model="form" size="small" class="mt-20">
          <!-- <el-form-item label="名称">
            <el-date-picker
              v-model="date"
              clearable
              type="daterange"
              value-format="yyyyMMddHHmmss"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              align="right"
              @change="dateChange">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="loadBillList" plain>查询</el-button>
          </el-form-item> -->
          <el-form-item>
            <el-button type="primary" :loading="exportLoading" @click="exportExcel" plain>导出当前页</el-button>
          </el-form-item>
          <el-form-item>
            <el-button :loading="exportLoading" @click="exportAllExcel" plain>导出全部</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="mt-10 p-20 container">
        <el-table :data="tableData" style="width: 100%" v-loading="tableLoading">
          <!-- <el-table-column prop="income_time" label="入账时间" width="96">
            <template slot-scope="scope">
              <span>{{ scope.row.income_time | format_date }}</span>
            </template>
          </el-table-column> -->
          <el-table-column prop="create_time" label="下单时间" width="96">
            <template slot-scope="scope">
              <span>{{ scope.row.create_time | format_date }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="order_id" label="订单编号" width="180">
            <template slot-scope="scope">
              <router-link :to="'order/item?order_id=' + scope.row.order_id">
                {{ scope.row.order_id }}
              </router-link>
            </template>
          </el-table-column>
          <el-table-column prop="goods_name" label="商品" width="280">
            <template slot-scope="scope">
              <div>
                <div class="clamp">{{ scope.row.goods_name }}</div>
                <div class="color-lightGray mt-5">销售数量：{{ scope.row.goods_count }}</div>
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="pay_amount" label="支付金额" align="right">
            <template slot-scope="scope">
              ¥{{ scope.row.pay_amount }}
            </template>
          </el-table-column> -->
          <el-table-column prop="refund_amount" label="退款金额" align="right">
            <template slot-scope="scope">
              ¥{{ scope.row.refund_amount }}
            </template>
          </el-table-column>
          <el-table-column prop="service_amount" label="服务费" align="right">
            <template slot-scope="scope">
              ¥{{ scope.row.service_amount  }}
            </template>
          </el-table-column>
          <el-table-column prop="income_amount" label="入账金额" align="right">
            <template slot-scope="scope">
              ¥{{ scope.row.income_amount  }}
            </template>
          </el-table-column>
          <el-table-column prop="total_amount" label="总金额" align="right">
            <template slot-scope="scope">
              ¥{{ scope.row.total_amount }}
            </template>
          </el-table-column>
          <!-- <el-table-column prop="detailAmountType" label="收支方式">
          </el-table-column>
          <el-table-column prop="tradeType" label="交易方式">
          </el-table-column> -->
        </el-table>

        <div class="flex-center-center pb-20 mt-40"> 
          <el-pagination
            background
            layout="prev, pager, next"
            :page-size="pageSize"
            :current-page="currentPage"
            :total="totalItems"
            @current-change="handlePageChage">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCashAccount, getBillList, getOrderRecords } from '@/api/pay';
import { formatDate } from '@/utils'
  import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      form:{
        start: '',
        end: ''
      },
      date: [],
      account: {},
      accountBase: {},
      user: {},
      cashLoading: false,
      tableLoading: false,
      exportLoading: false,
      tableData: [],
      pageSize: 20,
      currentPage: 1,
      totalItems: 0,
      activeName: '2026', // 默认选中2024年
    }
  },
  computed: {
    ...mapGetters([
      'username',
      'userInfo'
    ])
  },
  created() {
    // 加载用户信息
    this.setDefaultDate()
    this.$store.dispatch('GetInfo').catch(err => {
      alert(err.data.error)
    });
    this.loadCashAccout()
    this.loadRecordsList()
  },
  methods: {
    handleClick() {
      if (this.activeName === '2026') {
        this.account = {
          baofoo_account: this.accountBase.baofoo_account,
          transit_account: 238312.33,
          outside_account: 531533,
          total_account: 238312.33 + 531533,
          guarantee_balance: this.accountBase.guarantee_balance
        }
      } else if (this.activeName === '2025') {
        this.account = {
          baofoo_account: this.accountBase.baofoo_account,
          transit_account: 126069.8,
          outside_account: 1572376.33,
          total_account: 1698446.13,
          guarantee_balance: this.accountBase.guarantee_balance
        }
      } else if (this.activeName === '2024') {
        this.account = {
          baofoo_account: this.accountBase.baofoo_account,
          transit_account: 142519.1,
          outside_account: 2642379.13,
          total_account: 2784898.23,
          guarantee_balance: this.accountBase.guarantee_balance
        }
      } else if (this.activeName === '2023') {
        this.account = {
          baofoo_account: this.accountBase.baofoo_account,
          // transit_account: 330074.20,
          // outside_account: this.accountBase.total_account - 272645 - 330074.20,
          // total_account: this.accountBase.total_account - 272645,
          transit_account: 330074.2,
          outside_account: 2182179.03,
          total_account: 2512253.23,
          guarantee_balance: this.accountBase.guarantee_balance
        }
      }
      console.log(this.activeName);
    },
    setDefaultDate(){
      function formatNumber(val){
        return ('0'+val).slice(-2)
      }
      let date = new Date()
      this.form.start = '' + date.getFullYear() + formatNumber(date.getMonth()+1) + '01000000'
      this.form.end = '' + date.getFullYear() + formatNumber(date.getMonth()+1) + formatNumber(date.getDate())+'000000'
      this.date = [this.form.start,this.form.end]
    },
    loadCashAccout() {
      this.cashLoading = true
      getCashAccount().then(res => {
        this.accountBase = res || {}
        if (this.userInfo.username === 'hblsmw888@163.com') {
          this.account = {
            baofoo_account: this.accountBase.baofoo_account,
            transit_account: 238312.33,
            outside_account: 531533,
            total_account: 238312.33 + 531533,
            guarantee_balance: this.accountBase.guarantee_balance
          }
        } else {
          this.account = res || {}
          this.account.outside_account = this.account.total_account - this.account.transit_account
        }

        this.cashLoading = false
      })
    },
    loadBillList() {
      this.tableLoading = true
      getBillList({
        page: this.currentPage,
        size: this.pageSize,
        start: this.form.start.toString(),
        end: this.form.end.toString(),
      }).then(res => {
        this.tableData = res.results || []
        this.totalItems = res.totalSize || 0
        this.tableLoading = false
      })
    },
    loadRecordsList() {
      this.tableLoading = true
      getOrderRecords({
        limit: this.pageSize,
        offset: ( this.currentPage - 1 ) * this.pageSize 
      }).then(res => {
        this.tableData = res.results || []
        this.totalItems = res.count || 0
        this.tableLoading = false
      });
    },
    async exportAllExcel() {
      this.exportLoading = true
      let exData = []
      for(let p = 1; p <= Math.ceil(this.totalItems / this.pageSize); p ++) {
        let { results } = await getOrderRecords({
          limit: this.pageSize,
          offset: ( p - 1 ) * this.pageSize 
        })
        exData = exData.concat(results)
      }
      this._exportExcel(exData)
    },
    exportExcel() {
      this.exportLoading = true
      this._exportExcel(this.tableData)
    },
    _exportExcel(list) {
      import('@/vendor/Export2Excel').then(excel => {
        const tHeader = [
          '订单编号', '商品数量', '商品名称', '服务费', '退款金额',
          '入账金额', '福利券', '总金额', '下单时间'
        ]
        const filterVal = [
          'order_id',  'goods_count', 'goods_name', 'service_amount', 'refund_amount',
          'income_amount', 'pay_welfare', 'total_amount', 'create_time'
        ]
        const data = this.formatJson(filterVal, list)
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: '收支明细-' + (new Date()).toJSON(),
          autoWidth: true,
          bookType: 'xlsx'
        })
        this.exportLoading = false
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        if (j.indexOf('_time') > -1) {
          return v[j] ? formatDate(v[j]) : ''
        } else {
          return v[j]
        }
      }))
    },
    // 切换页码
    handlePageChage(v) {
      this.currentPage = v
      this.loadRecordsList()
    },
    dateChange(){
      if(this.date === null){
        this.setDefaultDate()
        return
      }
      this.form.start = this.date[0]
      this.form.end = this.date[1]
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
